import { inject } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ENVIRONMENT, enabledFeatureGuard, environmentGuard, reverseAuthenticatedGuard } from '@cfp/core';
import {
  AuthenticationPage,
  BuildingPublicSharedLinkInvalidPage,
  ChangePasswordPage,
  ForgotPasswordPage,
  LoggedOutPage,
  LoginPage,
  OtpAuthenticationPage,
  PasswordResetPage,
  PortfolioNotLoadedPage
} from './pages';
import { PiraeusSsoAuthenticationPage } from './pages/piraeus-sso-authentication';
import { SsoAuthenticationPage } from './pages/sso-authentication';
import { SsoOauthAuthenticationPage } from './pages/sso-oauth-authentication';
import { UnlockAccountPage } from './pages/unlock-account';
import { SsoAuthPathPage } from './paths';
import { DemoAnonymousLoginPage, DemoLoginPage } from './paths/demo';
import { LogoutPage } from './paths/logout';

const routes: Routes = [
  {
    path: 'login',
    children: [
      { path: 'demo', component: DemoLoginPage },
      { path: 'demo/login', component: DemoAnonymousLoginPage },
      {
        path: 'auth/login/auth-sso',
        component: SsoAuthPathPage,
        data: { featureName: 'ssoOauth' },
        canActivate: [enabledFeatureGuard]
      },
      {
        path: 'auth',
        component: AuthenticationPage,
        children: [
          {
            path: 'login',
            component: LoginPage,
            canActivate: [reverseAuthenticatedGuard],
            data: { appendPageTitle: 'login.title' }
          },
          { path: 'forgot', component: ForgotPasswordPage, data: { appendPageTitle: 'login.forgot' } },
          { path: 'change', component: ChangePasswordPage },
          {
            path: 'unlock',
            data: { permission: 'unlockAccount' },
            component: UnlockAccountPage,
            canActivate: [environmentGuard]
          },
          { path: 'logged-out', component: LoggedOutPage }
        ]
      },
      {
        path: 'mfa',
        component: AuthenticationPage,
        loadChildren: () => import('../mfa').then((m) => m.MfaRouterModule)
      },
      { path: 'otp', component: OtpAuthenticationPage },
      {
        path: 'sso',
        children: [
          {
            path: 'saml',
            component: SsoAuthenticationPage,
            data: { permission: 'ssoSaml' },
            canActivate: [environmentGuard]
          },
          {
            path: 'oauth',
            component: SsoOauthAuthenticationPage,
            data: { featureName: 'ssoOauth' },
            canActivate: [enabledFeatureGuard]
          },
          {
            path: 'piraeus-sso',
            component: PiraeusSsoAuthenticationPage,
            data: { featureName: 'piraeusSso' },
            canActivate: [enabledFeatureGuard]
          }
        ]
      },
      { path: 'portfolio-not-loaded', component: PortfolioNotLoadedPage },
      { path: 'reset', component: PasswordResetPage },
      { path: 'logout', component: LogoutPage },
      {
        path: '',
        redirectTo: () => {
          const environment = inject(ENVIRONMENT);
          return environment?.loginRoute || '/login/auth/login';
        },
        pathMatch: 'full'
      }
    ]
  },
  { path: 'logout', component: LogoutPage },
  { path: 'public/building-not-shared', component: BuildingPublicSharedLinkInvalidPage }
];

export const AuthenticationRouting = RouterModule.forChild(routes);
